import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeExercicioConsultaOrdensPagamentosExtraorcamentarias: [],
    removeDataOrdemInicialConsultaOrdensPagamentosExtraorcamentarias: [],
    removeDataOrdemFinalConsultaOrdensPagamentosExtraorcamentarias: [],
    removeDataPagamentoInicialConsultaOrdensPagamentosExtraorcamentarias: [],
    removeDataPagamentoFinalConsultaOrdensPagamentosExtraorcamentarias: [],
    removeAdministracaoConsultaOrdensPagamentosExtraorcamentarias: ['administracao'],
    removeSituacaoConsultaOrdensPagamentosExtraorcamentarias: [],
    removeDestinacaoConsultaOrdensPagamentosExtraorcamentarias: [],
    removeRecursoConsultaOrdensPagamentosExtraorcamentarias: [],
    removeNomeCredorConsultaOrdensPagamentosExtraorcamentarias: [],
    removeCnpjConsultaOrdensPagamentosExtraorcamentarias: [],
    removeCpfConsultaOrdensPagamentosExtraorcamentarias: [],
    setMostraAplicarFiltroConsultaOrdensPagamentosExtraorcamentarias: [],
    limpaFiltroConsultaOrdensPagamentosExtraorcamentarias: [],
    aplicarFiltroConsultaOrdensPagamentosExtraorcamentarias: ['filtro'],
})

const INITIAL_STATE = {
    exercicio: '',
    dataOrdemInicial: '',
    dataOrdemFinal: '',
    dataOrdemInicial: '',
    dataOrdemFinal: '',
    administracao: null,
    situacao: [],
    destinacao: null,
    recurso: null,
    nomeCredor: '',
    cnpj: '',
    cpf: '',
    mostraAplicarFiltro: false,
}
const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.administracao), 1)
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}
const removeExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: '', mostraAplicarFiltro: true }
}
const removeDataOrdemInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataOrdemInicial: '', mostraAplicarFiltro: true }
}
const removeDataOrdemFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataOrdemFinal: '', mostraAplicarFiltro: true }
}
const removeDataPagamentoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataPagamentoInicial: '', mostraAplicarFiltro: true }
}
const removeDataPagamentoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataPagamentoFinal: '', mostraAplicarFiltro: true }
}
const removeSituacao = (state = INITIAL_STATE, action) => {
    return { ...state, situacao: '', mostraAplicarFiltro: true }
}
const removeRecurso = (state = INITIAL_STATE, action) => {
    state.recurso.splice(state.recurso.indexOf(action.recurso), 1)
    state.recurso = Array.from(state.recurso)
    return { ...state, mostraAplicarFiltro: true }
}
const removeDestinacao = (state = INITIAL_STATE, action) => {
    state.destinacao.splice(state.destinacao.indexOf(action.destinacao), 1)
    state.destinacao = Array.from(state.destinacao)
    return { ...state, mostraAplicarFiltro: true }
}
const removeNomeCredor = (state = INITIAL_STATE, action) => {
    return { ...state, nomeCredor: '', mostraAplicarFiltro: true }
}
const removeCnpj = (state = INITIAL_STATE, action) => {
    return { ...state, cnpj: '', mostraAplicarFiltro: true }
}
const removeCpf = (state = INITIAL_STATE, action) => {
    return { ...state, cpf: '', mostraAplicarFiltro: true }
}
const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}
const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}
const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_EXERCICIO_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: removeExercicio,
    [Types.REMOVE_DATA_ORDEM_INICIAL_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: removeDataOrdemInicial,
    [Types.REMOVE_DATA_ORDEM_FINAL_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: removeDataOrdemFinal,
    [Types.REMOVE_DATA_PAGAMENTO_INICIAL_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: removeDataPagamentoInicial,
    [Types.REMOVE_DATA_PAGAMENTO_FINAL_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: removeDataPagamentoFinal,
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: removeAdministracao,
    [Types.REMOVE_SITUACAO_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: removeSituacao,
    [Types.REMOVE_RECURSO_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: removeRecurso,
    [Types.REMOVE_DESTINACAO_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: removeDestinacao,
    [Types.REMOVE_NOME_CREDOR_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: removeNomeCredor,
    [Types.REMOVE_CNPJ_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: removeCnpj,
    [Types.REMOVE_CPF_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: removeCpf,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: aplicarFiltro,
})
